import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectCurrent } from '../../../../redux/settings/selectors';
import { deepCopy } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';
import BlogPostComponent from '../components/blog-post/blog-post.component';


let currentChange: any = {}
const BlogPostContainer= ({ onSubmit,cardDetailInfo }: any) => {  
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [
    selectedBlog,
    setSelectedBlog
  ] = useState<any>([])
  const [
    blogPostImageIndex,
    setBlogPostImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


//   const fetchBlogPostById= ()=>{
//     dispatch(blogPosts.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts/query`,entity:'blogPosts',jsonData:{
          
//     Records: [
//       {
        
          
//               "Id": parmas?.id
          
      
       
//       }
//     ]
  
// }})).then(()=>{
//     dispatch(blogPostFiles.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-post-files/query-by-blog-post`,entity:'blogPostFiles',jsonData:{
          
//         Records: [
//           {
            
              
//                   "BlogPostId": parmas?.id
              
          
           
//           }
//         ]
      
//     }}))}).then(()=>{

//   setIsQuery(true)
// })




//   }

const handleFormBlogPostItemChange: any = ({ value, field, idx }: any) => {
  const items = deepCopy(selectedBlog);// deep copy of grn items
  let item = items[idx];// deep copy of item to be edited
  item = { ...item, [field]: value }// updated the particular item
  items[idx] = item;
  currentChange = { value, field, idx }
  setSelectedBlog(items);
}


  useEffect(
    () => {
      if (cardDetailInfo) {
        const localSelectedBlogPost = addNewRow({ selectedBlogPostArg: cardDetailInfo });
        setSelectedBlog(localSelectedBlogPost)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: cardDetailInfo?.BlogPostDocumentURLs });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
    }else {
      const localSelectedBlogPost = addNewRow({ selectedBlogPostArg: selectedBlog });
      setSelectedBlog(localSelectedBlogPost)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  const addNewRow = ({ selectedBlogPostArg }: any) => {
    const localSelectedBlogPost = Array.isArray(selectedBlogPostArg)
        ? deepCopy(selectedBlogPostArg)
        : Object.values(deepCopy(selectedBlogPostArg));

    console.log(localSelectedBlogPost, 'localSelectedSocialProfile');

    const newsSelectedMedia = {
       Id: 0,
      Title: '',
      Body:'',
      Caption: '',
      IsCommentsAllowed: false,
      BlogShowStartDateUtc: '',
      BlogShowEndDateUtc: '',
      MetaKeywords: '',
      MetaDescription: '',
      MetaTitle: '',
      IsLimitedToStores: false,
      BlogPostDocumentURLs: [
        {
          Id: 0,
          BlogPostId: 0,
          FileTypeId: 0,
          BlogPostFileURL: "string"
        }
      ]
    
    };

    if (
      localSelectedBlogPost.length === 0 ||
      localSelectedBlogPost[localSelectedBlogPost.length - 1]?.Title !== ''
    ) {
      localSelectedBlogPost.push(newsSelectedMedia);
    }

    return localSelectedBlogPost;
};
  const setCombinationBlogPostInfo = async () => {
    let localSelectedBlogPost = deepCopy(selectedBlog)
    localSelectedBlogPost.splice(
      currentChange.idx,
      1,
      { ...localSelectedBlogPost[currentChange.idx] }
    );
    localSelectedBlogPost = addNewRow({ selectedBlogPostArg: localSelectedBlogPost });
    currentChange.field = 'TitleDONE'
    setSelectedBlog(localSelectedBlogPost)
  }

  useEffect(
    () => {
      if (currentChange.field === 'Title') {
        setCombinationBlogPostInfo()
      }
    },
    [selectedBlog]
  )

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }
const handleFormSubmit  = async (event: any) => {
  selectedBlog.splice(
    selectedBlog.length - 1,
    1
  );
   onSubmit(selectedBlog)

  }
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
        Id: 0,
        BlogPostId: parmas?.id,
        FileTypeId: 0,
        BlogPostFileUrl: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  // const changeImage = (idx: number, templateField: any, fileType: any) => {
  //   setBlogPostImageIndex(idx)
  //   dispatch(settings.set({ getUploadFiles: 'open' }))
  //   setOpenFile({
  //     currentFileSrc: mediaFiles[idx][templateField],
  //     folder: 'BlogPost',
  //     type: fileType
  //   })
  // }
  const handleSubmit = (data: any) => {
  
    mediaFiles[blogPostImageIndex].BlogPostFileUrl = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  // const handleClose = () => {
  //   dispatch(settings.set({ getUploadFiles: 'close' }))
    
  // }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
     {/* {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         />} */}
    {isLoading ? <PageLoader /> : 
          <BlogPostComponent
          handleFormBlogPostItemChange={handleFormBlogPostItemChange}
          handleFormSubmit={handleFormSubmit}
          selectedBlog={selectedBlog}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          />
        }
    
          </>
    )
    
    }
   
    export default BlogPostContainer;
